// Import necessary Material-UI components
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

// Import custom CSS
import "./qualityReportGroup.css";
import { HistoricalReportDetails, QualityReportDetails } from "./";

/**
 * QualityReportDetailsDialog component for displaying and exporting quality report details.
 * @param {Object} props - Component props including rowData, modal open state, and handleClose callback.
 */
export function QualityReportDetailsDialog({ rowData, open, handleClose }) {
  // Rendering the dialog component for quality report details
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      sx={{ height: "90%" }}
    >
      <DialogTitle>Quality Report Details</DialogTitle>

      <DialogContent>
        {rowData?.historicalReport ? (
          <HistoricalReportDetails rowData={rowData} />
        ) : (
          <QualityReportDetails rowData={rowData} />
        )}
      </DialogContent>
      {/* Dialog actions with cancel button */}
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
